export enum TransactionType {
  BOOKING_CREDIT = 'Booking Credit',
  BOOKING_CREDIT_CORRECTION = 'Booking Credit Correction',
  BOOKING_CREDIT_EXPIRATION = 'Booking Credit Expiration',
  BOOKING_DEBIT = 'Booking Debit',
  BOOKING_DEBIT_CORRECTION = 'Booking Debit Correction',
  BOOKING_DEBIT_EXPIRATION = 'Booking Debit Expiration',
  BOOKING_REDEMPTION = 'Booking Redemption',
  BOOKING_REFUND = 'Booking Refund',
  CORRECTION = 'Correction',
  CREDIT = 'Credit',
  DEBIT = 'Debit',
  DEBIT_CORRECTION = 'Debit Correction',
  REDEMPTION_REFUND = 'Redemption Refund',
  REDEMPTION_REFUND_CORRECTION = 'Redemption Refund Correction',
  RETURN = 'Return',
  RETURN_CORRECTION = 'Return Correction',
}
